import type { ButtonProps } from '@wartek-id/button-v1'
import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'

export type TKinerjaErrorAction = {
  text: string | React.ReactNode
  action: () => void
  variant?: ButtonProps['variant']
  color?: ButtonProps['color']
  className?: string
}

type KinerjaErrorProps = {
  title?: any
  icon?: any
  ctaAction?: TKinerjaErrorAction
  secondaryCtaAction?: TKinerjaErrorAction
  children?: any
}

const KinerjaError: FC<KinerjaErrorProps> = ({
  title,
  icon: Icon,
  ctaAction,
  secondaryCtaAction,
  children,
}) => {
  return (
    <div className="bg-white h-screen flex items-start">
      <div className="mt-32 mx-auto max-w-xl flex flex-col gap-8">
        {Icon && <Icon width={120} height={120} />}

        <div className="flex flex-col gap-4">
          <Text variant="display-sm">{title}</Text>

          <div>{children}</div>
        </div>

        <div className="flex gap-5">
          {ctaAction && (
            <Button
              size="lg"
              variant={ctaAction.variant || 'solid'}
              color={ctaAction?.color || 'blue'}
              className={ctaAction.className}
              onClick={ctaAction.action}
            >
              {ctaAction.text}
            </Button>
          )}

          {secondaryCtaAction && (
            <Button
              size="lg"
              variant={secondaryCtaAction.variant || 'ghost'}
              color={secondaryCtaAction?.color || 'blue'}
              className={secondaryCtaAction.className}
              onClick={secondaryCtaAction.action}
            >
              {secondaryCtaAction.text}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
export default KinerjaError
